import React, { useEffect, useRef, forwardRef } from 'react';
import * as d3 from 'd3';


const AreaChart = forwardRef(({ geojson, currentProperty, isChecked, currentCategory }, ref) => {
    const chartRef = useRef(null);

    useEffect(() => {
      if (!geojson) return;
      const svg = d3.select(chartRef.current);

      const margin = { top: 20, right: 30, bottom: 30, left: 40 };
      const width = 1500;
      const height = 502;
      const barHeight = 500;

      const mappingArray = [
        { label: '民主指数', value: 'demoIndex'},
        { label: '公正自由选举指数', value: 'equalIndex'},
        { label: '民主分类', value: 'classification'}
      ];

      let sortedData;

      if (currentProperty === "classification") {
        const customSortOrder = ['Full Democracy', 'Flawed Democracy', 'Hybrid Regime', 'Authoritarian Regime'];

        sortedData = geojson.features.sort((a, b) => {
          const aIndex = customSortOrder.indexOf(a.properties[currentProperty]);
          const bIndex = customSortOrder.indexOf(b.properties[currentProperty]);
          return aIndex - bIndex;
        });
      } else {
        sortedData = geojson.features.sort((a, b) => a.properties[currentProperty] - b.properties[currentProperty]);
      }

      const cumulativeWidths = sortedData.map(d => d.properties.population).reduce((acc, val) => {
        const lastVal = acc.length > 0 ? acc[acc.length - 1] : 0;
        acc.push(lastVal + val);
        return acc;
      }, []);

      const xScale = d3.scaleLinear()
        .domain([0, d3.sum(sortedData, d => d.properties.population)])
        .range([0, width]);
      
      let colorScale;
      if (currentProperty === "equalIndex") {
        colorScale = d3.scaleLinear()
            .domain([0, d3.max(geojson.features, d => d.properties[currentProperty])])
            .range(['#000', '#FFDD29']);
      } else if (currentProperty === "demoIndex") {
          colorScale = d3.scaleLinear()
              .domain([0, d3.max(geojson.features, d => d.properties[currentProperty])])
              .range(['#000', '#0BFF50']);
      } else if (currentProperty === "classification") {
          colorScale = d3.scaleOrdinal()
              .domain(['Full Democracy', 'Flawed Democracy', 'Hybrid Regime', 'Authoritarian Regime'])
              .range(['#06ED47', '#EEE50E', '#D77D29', '#EC1D1D']);
      } else {
        colorScale = d3.scaleLinear()
          .domain([0, d3.max(geojson.features, d => d.properties[currentProperty])])
          .range(['#000', '#000']); // Default color if currentProperty is unknown
      }
      
      d3.select(chartRef.current).selectAll("*").remove();

      svg.attr('viewBox', `0 0 ${width} ${height}`)

      const handleMouseOver = (event, d) => {
        d3.select(event.target)
          .attr('stroke', 'white')  // Add a border
          .attr('stroke-width', 3);
          
        d3.select(ref.current)
          .style('display', 'block')
          .html(`
              <h3>${d.properties.country_cn}</h3>
              ${mappingArray.find(item => item.value === currentProperty).label}: ${d.properties[currentProperty]}
              <br>
              人口: ${parseInt(d.properties.population * 100)}万
          `);
    };

    const handleMouseMove = (event) => {
      d3.select(ref.current)
        .style('left', (event.pageX + 10) + 'px')
        .style('top', (event.pageY - 25) + 'px');
    };
    
      const handleMouseOut = (event) => {
        d3.select(event.target)
          .attr('stroke', null)
          .attr('stroke-width', null);
          
        d3.select(ref.current)
          .style('display', 'none');
      };
      
      const bars = svg.selectAll("rect")
        .data(sortedData)
        .enter().append('rect')
        // .attr('class', 'bar')
        .attr('x', (d, i) => i === 0 ? 0 : xScale(cumulativeWidths[i - 1]))
        .attr('y', height / 2 - barHeight / 2)
        .attr('width', d => xScale(d.properties.population))
        .attr('height', barHeight)
        .attr("fill", d => colorScale(d.properties[currentProperty]))
        .attr('opacity', d => {
          // Set opacity based on currentCategory filter
          if (currentCategory === "" || d.properties[currentCategory] === 1) {
              return 0.7;
          } else {
              return 0; // Hide bars that do not match currentCategory
          }
        })
        .on('mouseover', handleMouseOver)
        .on('mousemove', handleMouseMove)
        .on('mouseout', handleMouseOut) 
    }, [geojson, currentProperty, currentCategory]);

    return (
        <>
          <svg className="area__chart" ref={chartRef} style={{ opacity: isChecked ? 1 : 0, transition: "opacity 0.5s", pointerEvents: isChecked ? "auto" : "none" }}></svg>
        </>
    );
});

export default AreaChart;
